module.exports = __webpack_public_path__ + "img/HRD.e811be0.jpg";